import { SyntheticEvent, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';

import { useAppDispatch } from 'app/hooks';
import { FormMsg, NoFormMsg, doFormMsg } from 'components/forms/FormMessage';
import { ModalDialog, ModalDialogLink } from 'components/modal/Modal';
import { userForgotAsync } from 'features/user/userSlice';
import { getPattern } from 'helpers/regex';
import UserLoginForm from './UserLoginForm';
import UserSignupForm from './UserSignupForm';

export default function UserForgotForm() {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const [data, setData] = useState({
    email: '',
  });
  const [hasRequested, setHasRequested] = useState<boolean>(false);
  const [validForm, setValidForm] = useState<boolean>(true);
  const [formMsg, setFormMsg] = useState<FormMsg>(NoFormMsg);

  function handleChangeData(e: SyntheticEvent) {
    const target = e.target as HTMLInputElement;
    setData({
      ...data,
      [target.name]: target.value,
    });
  }

  async function handleSubmit(): Promise<boolean | number> {
    return new Promise((resolve, reject) => {
      try {
        if (hasRequested) {
          resolve(true);
        } else
          dispatch(userForgotAsync(data)).then((response: { payload: any }) => {
            switch (response.payload?.response.status) {
              // TODO catch cases 20x, whichever is returned and catch failure responses
              default:
                doFormMsg(
                  {
                    message: intl.formatMessage({ id: 'USERS.FORGOT.SUCCESS' }),
                    success: true,
                  },
                  setFormMsg,
                );
                setHasRequested(true);
                resolve(5000);
                break;
            }
          });
      } catch (err) {
        setValidForm(false);
        doFormMsg(
          {
            message: intl.formatMessage({ id: 'X.FAILED_UNKNOWN' }),
            success: false,
          },
          setFormMsg,
        );
        reject(intl.formatMessage({ id: 'X.FAILED_UNKNOWN' }));
      }
    });
  }

  return (
    <ModalDialog
      className="user_form narrow"
      title={<FormattedMessage id="USERS.FORGOT.FORM_TITLE" />}
      okBtn={{
        label: intl.formatMessage({
          id: hasRequested ? 'X.OK' : 'USERS.FORGOT.SUBMIT',
        }),
        onClick: handleSubmit,
      }}
      footerRight={
        hasRequested ? undefined : (
          <ModalDialogLink component={UserSignupForm} asButton closeAll>
            <FormattedMessage id="USERS.LOGIN.NEW_USER" />
          </ModalDialogLink>
        )
      }
      enableEscape
      formMsg={formMsg}
      validated={!validForm}
      setValidForm={setValidForm}
    >
      <Row>
        <Col sm={12} md={12} lg={12}>
          <FormattedMessage id="USERS.FORGOT.FORM_TEXT" />
        </Col>
      </Row>
      <Form.Group as={Row} controlId="Email">
        <Form.Label column sm="12" md="12" lg="12">
          <FormattedMessage id="USERS.LOGIN.EMAIL" />
        </Form.Label>
        <Col sm={12} md={12} lg={12}>
          <Form.Control
            type="email"
            name="email"
            autoComplete="username email"
            value={data.email || ''}
            onChange={handleChangeData}
            required
            pattern={getPattern('email')}
          />
          <Form.Control.Feedback type="invalid">
            <FormattedMessage id="USERS.LOGIN.EMAIL_FDBCK" />
          </Form.Control.Feedback>
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="form">
        <Col align={'left'} sm={12}>
          <div className="vspaced">
            <ModalDialogLink component={UserLoginForm} closeAll>
              <FormattedMessage id="USERS.FORGOT.TRY_AGAIN" />
            </ModalDialogLink>
          </div>
        </Col>
      </Form.Group>
    </ModalDialog>
  );
}
